var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.338,
    height: 19.089,
    viewBox: "0 0 17.338 19.089",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-4);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.96,
    y1: -0.367,
    x2: -0.335,
    y2: 0.309,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00a1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00beff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#00d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00dfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00e3ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.13,
    y1: -0.709,
    x2: -1.245,
    y2: -0.709,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#ffbd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9c00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.398,
    y1: -1.279,
    x2: -0.963,
    y2: 0.507,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff3a44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.65,
    y1: -0.705,
    x2: -0.042,
    y2: 0.092,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32a071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2da771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#15cf74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#06e775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00f076"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "translate(0 -0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(0 0.01)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g48",
    transform: "translate(0 0.241)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    className: "cls-1",
    d: "M198.259,183.744a1.467,1.467,0,0,0-.349,1.043V201.2a1.477,1.477,0,0,0,.349,1.046l.054.05,9.306-9.2v-.217l-9.306-9.194Z",
    transform: "translate(-197.91 -183.69)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(9.707 6.368)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path78",
    className: "cls-2",
    d: "M395.9,313.06l-3.1-3.066v-.217l3.1-3.066.069.04,3.675,2.067c1.046.586,1.046,1.552,0,2.142l-3.674,2.062Z",
    transform: "translate(-392.8 -306.71)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g80",
    transform: "translate(0.349 9.543)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path88",
    className: "cls-3",
    d: "M217.441,373.585l-3.171-3.135-9.36,9.252a1.234,1.234,0,0,0,1.561.044l10.97-6.161",
    transform: "translate(-204.91 -370.45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g90",
    transform: "translate(0.349 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path104",
    className: "cls-4",
    d: "M217.441,185.268l-10.97-6.161a1.234,1.234,0,0,0-1.561.05l9.36,9.246Z",
    transform: "translate(-204.91 -178.86)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.150e07c7556e0439f7dac9975bace358.svg";
export { ForwardRef as ReactComponent };